import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Star, Trash2 } from "lucide-react";

const AdminReviews = () => {
  const [reviews, setReviews] = useState([]);
  const load = () => api.get("/reviews").then(r => setReviews(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Delete review?")) return;
    await api.delete(`/admin/reviews/${id}`);
    toast.success("Deleted"); load();
  };

  return (
    <div data-testid="admin-reviews-page">
      <p className="eyebrow mb-1">Feedback</p>
      <h1 className="font-hero text-3xl mb-6">Reviews</h1>
      {reviews.length === 0 ? <p className="text-charcoal/70">No reviews yet.</p> : (
        <div className="space-y-3">
          {reviews.map(r => (
            <div key={r.id} className="bg-white rounded-2xl border border-border p-5 flex justify-between gap-4">
              <div>
                <div className="flex items-center gap-1 text-gold mb-1">{Array.from({ length: r.rating }).map((_, i) => <Star key={i} size={13} fill="currentColor" stroke="none" />)}</div>
                <p className="font-cormorant text-lg">{r.title}</p>
                <p className="text-sm text-charcoal/80">{r.body}</p>
                <p className="font-label text-[11px] uppercase tracking-[0.22em] text-charcoal/70 mt-1">— {r.author_name}</p>
              </div>
              <button className="text-rose self-start" onClick={() => remove(r.id)} aria-label="delete"><Trash2 size={14} /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminReviews;
